// extracted by mini-css-extract-plugin
module.exports = {"switchV2__primary":"switchV2__primary-319iT","switchV2__main":"switchV2__main-2nVyy","switchV2__active":"switchV2__active-2QD2r"};